import type { AxiosError } from "axios"

export interface ErrorDetails {
  message: string
  statusCode?: number
  context?: string
}

/**
 * Centralized error handling for the Klantportaal
 */
export function useErrorHandler() {
  function handleError(error: unknown, context?: string): ErrorDetails {
    const axiosError = error as AxiosError

    let message = "Er is een fout opgetreden"
    let statusCode: number | undefined

    if (axiosError.response) {
      statusCode = axiosError.response.status

      switch (axiosError.response.status) {
        case 400:
          message = "Ongeldige gegevens"
          break
        case 401:
          message = "U bent niet geautoriseerd"
          break
        case 403:
          message = "U heeft geen toegang tot deze functie"
          break
        case 404:
          message = "De gevraagde gegevens zijn niet gevonden"
          break
        case 422:
          message = "De ingevoerde gegevens zijn ongeldig"
          break
        case 500:
          message = "Er is een serverfout opgetreden"
          break
        default:
          message = `Fout: ${axiosError.response.status}`
      }
    } else if (axiosError.request) {
      message = "Geen verbinding met de server"
    }

    console.error("API Error:", {
      context,
      error: axiosError,
      message
    })

    return {
      message,
      statusCode,
      context
    }
  }

  return { handleError }
}
